import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { PatternLayer, patternLight } from "./patterns";

const GUIDES = [
  {
    to: "/lab-grown-diamonds",
    tag: "Diamonds",
    title: "Lab-Grown Diamonds, Explained Honestly",
    image: "/assets/lab-guide-hero.jpg",
  },
  {
    to: "/diamond-buying-guide",
    tag: "Diamonds",
    title: "How to Buy a Diamond Without Overpaying",
    image: "/assets/diamond-guide-hero.jpg",
  },
  {
    to: "/gold-karat-guide",
    tag: "Gold",
    title: "10K vs 14K vs 18K — What the Stamp Means",
    image: "/assets/gold-guide-hero.jpg",
  },
  {
    to: "/pre-owned-watch-guide",
    tag: "Watches",
    title: "Buying a Pre-Owned Swiss Watch, the Smart Way",
    image: "/assets/watch-guide-hero.jpg",
  },
];

export const GuidesHub = () => {
  return (
    <section className="relative overflow-hidden py-20 lg:py-28" data-testid="guides-hub">
      <PatternLayer pattern={patternLight} />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <Reveal className="max-w-2xl">
          <Eyebrow>From the Jeweler's Bench</Eyebrow>
          <h2 className="font-display text-4xl md:text-5xl font-light tracking-tight text-neutral-900" data-testid="guides-hub-heading">
            Buy it smart, <span className="text-[#C9A227]">before you buy it</span>
          </h2>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-neutral-600">
            Straight answers from our team — the same guidance we give at the counter,
            written down for you to keep.
          </p>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {GUIDES.map((g, i) => (
            <Reveal key={g.to} delay={0.06 * i}>
              <Link
                to={g.to}
                data-testid={`guides-hub-card-${i}`}
                className="group block bg-white border border-[#E8DCC4] rounded-sm overflow-hidden hover:border-[#C9A227] hover:-translate-y-1 hover:shadow-[0_20px_40px_rgb(201,162,39,0.12)] transition-[border-color,transform,box-shadow] duration-300 h-full"
              >
                <div className="overflow-hidden">
                  <img
                    src={g.image}
                    alt={g.title}
                    loading="lazy"
                    className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                  />
                </div>
                <div className="p-5">
                  <span className="text-[10px] uppercase tracking-[0.18em] text-[#C9A227] font-semibold">{g.tag}</span>
                  <h3 className="font-display text-base text-neutral-900 mt-2 leading-snug">{g.title}</h3>
                  <span className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-[#A8871B]">
                    Read the guide <ArrowRight size={13} strokeWidth={1.5} className="group-hover:translate-x-1 transition-transform duration-300" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
